import React, { FC } from 'react';
import { PhotoDetailImage, SwiperSlideWrapper } from './styled';

type MainSwiperSlideProps = {
  src: string;
  alt: string;
};

export const MainSwiperSlide: FC<MainSwiperSlideProps> = ({ src, alt }) => {
  return (
    <SwiperSlideWrapper>
      <PhotoDetailImage src={src} alt={alt} />
    </SwiperSlideWrapper>
  );
};
